<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" id="modal-form-estado">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Actualizar Estado</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="estado">Estado</label>
              <select
                id="estado"
                class="form-control form-control-sm"
                v-model="form_estado.estado"
                :class="
                  $v.form_estado.estado.$invalid ? 'is-invalid' : 'is-valid'
                "
                @change="ajustaCamposEstado"
              >
                <option value="">Seleccione...</option>
                <option
                  v-for="estado in $parent.listasForms.estados"
                  :key="estado.numeracion"
                  :value="estado.numeracion"
                >
                  {{ estado.descripcion }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label for="justificacion">Justificación</label>
              <textarea
                v-model="form_estado.justificacion"
                cols="30"
                rows="5"
                class="form-control form-control-sm"
                :class="
                  $v.form_estado.justificacion.$invalid
                    ? 'is-invalid'
                    : 'is-valid'
                "
              ></textarea>
            </div>
            <div
              class="form-group"
              v-if="
                form_estado.estado == 2
              "
            >
              <label>Fecha Reactivación</label>
              <input
                type="date"
                v-model="form_estado.fecha_reactivacion"
                class="form-control form-control-sm"
                :class="
                  $v.form_estado.fecha_reactivacion
                    ? $v.form_estado.fecha_reactivacion.$invalid
                      ? 'is-invalid'
                      : 'is-valid'
                    : ''
                "
                @input="validaFechas"
              />
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-primary"
              v-show="!$v.form_estado.$invalid"
              @click="save()"
            >
              Guardar
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "FuncionarioEstado",
  data() {
    return {
      form_estado: {
        estado: null,
      },
    };
  },
  validations() {
    if (
      this.form_estado.estado == 2
    ) {
      return {
        form_estado: {
          estado: {
            required,
          },
          fecha_reactivacion: {
            required,
          },
          justificacion: {
            required,
            minLength: minLength(10),
          },
          entidad_id: {
            required,
          },
          entidad: {
            required,
          },
        },
      };
    } else {
      return {
        form_estado: {
          estado: {
            required,
          },
          justificacion: {
            required,
            minLength: minLength(10),
          },
          entidad_id: {
            required,
          },
          entidad: {
            required,
          },
        },
      };
    }
  },
  methods: {
    save() {
      if (!this.$v.form_estado.$invalid) {
        axios({
          method: "PUT",
          url: "/api/admin/funcionarios",
          data: this.form_estado,
        })
          .then((response) => {
            this.form_estado = {};
            this.$refs.closeModal.click();
            this.$swal({
              icon: "success",
              title: "Se realizo el cambio de estado exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          })
          .catch((e) => {
            this.cargando = false;
            this.$swal({
              icon: "error",
              title: "Ocurrio un error, vuelva a intentarlo..." + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
        this.$parent.getIndex();
      }
    },

    llenar_modal(funcionario) {
      let fecha_reactivacion = null;
      if (funcionario.estado == 2) {
        fecha_reactivacion = funcionario.fecha_reactivacion;
      }
      this.form_estado = {
        entidad_id: funcionario.id,
        entidad: "Funcionarios",
        id: funcionario.id,
        user_id: funcionario.user_id,
        estado: funcionario.estado,
        valor_ant: funcionario.estado,
        // justificacion,
        fecha_reactivacion,
        user: this.$store.state.user.id,
      };
    },

    ajustaCamposEstado() {
      if (this.form_estado.estado == 1) {
        this.form_estado.fecha_reactivacion = "";
      }
    },

    validaFechas() {
      if (this.form_estado.fecha_reactivacion) {
        const fecha_menor = new Date();
        const fecha_mayor = new Date(this.form_estado.fecha_reactivacion);
        // Se valida que la fecha inicial sea menor que la fecha final
        if (fecha_menor > fecha_mayor) {
          this.form_estado.fecha_reactivacion = null;
          this.$swal({
            icon: "error",
            title: `La fecha de reactivación no puede ser menor a la fecha actual...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
    },
  },
};
</script>